"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockPdfDownloaderResult = void 0;
exports.mockPdfDownloaderResult = function (mockRequestPdfDownload) { return ({
    requestPDfDownload: mockRequestPdfDownload,
    requestStatus: 'initial',
    pdfFile: undefined,
}); };
//# sourceMappingURL=mockPdfDownloaderResult.js.map